import React from "react";
import { Delete as DeleteIcon } from "@mui/icons-material";
import type { Template } from "./types";
import { ConfirmDialog } from "../../shared/ui";

interface DeleteConfirmDialogProps {
  open: boolean;
  template: Template | null;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  open,
  template,
  isDeleting,
  onClose,
  onConfirm,
}) => {
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      tone="error"
      iconVariant="tinted"
      icon={<DeleteIcon />}
      title="Delete Template"
      description={
        <>
          Are you sure you want to delete &ldquo;
          {template?.fileName || template?.name || "this template"}
          &rdquo;? This action cannot be undone.
        </>
      }
      confirmLabel="Delete Template"
      loading={isDeleting}
    />
  );
};

export default DeleteConfirmDialog;
